<script setup lang="ts">
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import { Head } from "@unhead/vue/components";
import RealityAppLayout from "@/Layouts/RealityAppLayout.vue";

const page = usePage();
const userName = computed(
    () => (page.props.user as { name?: string } | null)?.name ?? "",
);
</script>

<template>
    <Head title="Reality dashboard" />

    <RealityAppLayout>
        <div class="max-w-4xl px-6 py-12 mx-auto">
            <h1 class="text-2xl font-semibold text-iron-900">
                {{ $t("reality.dashboard.greeting", { name: userName }) }}
            </h1>
            <p class="mt-2 text-iron-600">
                {{ $t("reality.dashboard.placeholder") }}
            </p>
        </div>
    </RealityAppLayout>
</template>
